import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { ReactComponent as ClimateHoundLogoSVGSrc } from './ClimateHound_Logo.svg'

export default function ChLogo(props) {
  return <SvgIcon sx={props.sx} component={ClimateHoundLogoSVGSrc} inheritViewBox />
}
